import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  linkVndlyCandidate,
  type LinkVndlyCandidateParams,
} from 'api/admin/vndly/linkVndlyCandidate'
import { vndlyKeys } from './keys'

export const useLinkVndlyCandidateMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: LinkVndlyCandidateParams) =>
      linkVndlyCandidate(params),
    onSuccess: async () =>
      queryClient.invalidateQueries({ queryKey: vndlyKeys.candidateIssues() }),
  })
}
